import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { airplaneStates } from './types';

export interface HighflyerAirPlaneProps {
  currentState: airplaneStates;
  isAnimating: boolean;
}

const initialState: HighflyerAirPlaneProps = {
  currentState: airplaneStates.READY_TO_FLY,
  isAnimating: false,
};

export const airPlaneSlice = createSlice({
  name: 'highflyerAirPlane',
  initialState: initialState,
  reducers: {
    setCurrentState: (state, aciton: PayloadAction<airplaneStates>) => {
      state.currentState = aciton.payload;
      if (aciton.payload === airplaneStates.READY_TO_FLY) {
        state.isAnimating = true;
      }
    },
    resetIsAnimating: (state): void => {
      state.isAnimating = false;
    },
  },
});

export const airPlaneActions = airPlaneSlice.actions;
